/**
 * Lecturas del módulo Polipay Payments (feature 52).
 *
 * Por qué existe: `/api/v1/payments/` está excluido del interceptor de sesión POR
 * PREFIJO, y esa exclusión se puso por el modal de error GLOBAL (cada pantalla de
 * payments pinta su propio mensaje: tarjeta declinada, PCI 400, 3DS, 409 de links).
 * Como efecto colateral apagaba también la RENOVACIÓN de sesión en todo el módulo,
 * así que un 401 de token vencido en una lectura nunca avisaba ni renovaba.
 *
 * Este predicado separa las dos decisiones: las LECTURAS de payments renuevan la
 * sesión como cualquier otra lectura; las escrituras siguen fuera, porque el
 * reintento tras renovar cierra la sesión si falla (un 409 esperado al cancelar un
 * QR deslogearía al operador) y porque un step-up TOTP responde 401 "expirado".
 *
 * Puro: cero Angular. Se decide por la RUTA (sin query ni fragmento) para que un
 * parámetro como `?next=/api/v1/payments/` no convierta en lectura de payments a
 * cualquier URL.
 */

/** Prefijo del módulo Polipay Payments. Lo usa también la lista de exclusiones. */
export const PREFIJO_PAYMENTS = '/api/v1/payments/';

/** `Set` y no arreglo: membresía O(1) en la ruta caliente del interceptor. */
const METODOS_DE_LECTURA: ReadonlySet<string> = new Set(['GET', 'HEAD']);

/** Corta la query y el fragmento: la decisión es por ruta. */
function rutaDe(url: string): string {
  const corte = url.search(/[?#]/);
  return corte === -1 ? url : url.slice(0, corte);
}

export function esLecturaDePayments(method: string, url: string): boolean {
  return METODOS_DE_LECTURA.has(method.toUpperCase()) && rutaDe(url).includes(PREFIJO_PAYMENTS);
}
